<template lang="pug">
.container-fluid
  .row.d-flex.flex-nowrap.flex-column.flex-md-row
    .card_img
      img(:src="homeData.area05_Image")
    .card_content.d-flex.justify-content-between.position-relative
      .content
        p.date.i_body.text {{ homeData.area05_Date }}
        p.place.i_body.text {{ homeData.area05_Department }}
          span.i_body.name.text.ml-4 {{ homeData.area05_Service }}
        p.case.i_body.text(
          v-if="homeData.area05_Number && homeData.area05_Number != ''"
        ) 案號 {{ homeData.area05_Number }}
          span.i_body.case.text.ml-4(
            v-if="homeData.area05_Insured && homeData.area05_Insured != ''"
          ) 被保險人：{{ homeData.area05_Insured }}
        p.i_body_l.text_l(v-html="homeData.area05_Content") 
        router-link.d-block.d-md-none.d-lg-block(:to="'/thanks'")
          .see_more_btn.sm.btn_blue_ci.float-md-right.i_mb_sm_12.i_mt_sm_8 看更多
      img.dec_img.d-none.d-lg-block(:src="homeData.area05_Image1")
      img.subtract.d-none.d-lg-block(:src="subtractImg")

  .row.justify-content-center.d-none.d-md-block.d-lg-none.i_mt_6.i_mb_10
    router-link.d-flex(:to="'/thanks'")
      .see_more_btn.btn_blue_ci 看更多
</template>

<script>
import subtractImg from "@/assets/img/icon/subtract.png";

export default {
  name: "ThankYouCard",
  props: {
    homeData: Object,
  },
  data() {
    return {
      subtractImg: subtractImg,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/thank_you_card";
</style>
